import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { SalesCopy } from './components/SalesCopy';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { Pricing } from './components/Pricing';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen bg-[#FDF8F3] text-[#2D3436] font-sans selection:bg-[#9CAF88] selection:text-white" data-id="element-0">
      <UrgencyBar data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />

        <SalesCopy data-id="element-4" />

        <Bonuses data-id="element-5" />

        <Pricing data-id="element-6" />

        <Testimonials data-id="element-7" />
      </main>

      <footer className="bg-[#2D3436] text-[#E8D5D5] py-12 px-4 text-center" data-id="element-8">
        <div className="max-w-4xl mx-auto" data-id="element-9">
          <h3 className="font-serif text-2xl mb-4" data-id="element-10">Yoga Esencial</h3>
          <p className="text-sm opacity-70 mb-8" data-id="element-11">
            Un sistema integral para el bienestar real.
          </p>
          <p className="text-xs opacity-50" data-id="element-12">
            &copy; {new Date().getFullYear()} Yoga Esencial. Todos los derechos
            reservados.
            <br data-id="element-13" />
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      <PurchasePopup data-id="element-14" />
    </div>;
}